import IComponent from "components/commons/IComponent";
import EditableDatagridCell from "./EditableDatagridCell";
import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@material-ui/core";
import "./FilterList.scoped.css";

class FilterList extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      filterKeyword: "",
    };
  }
  componentDidMount() {}
  componentWillUnmount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  renderListItem() {
    let filteredResult = this.props.listData.reduce(
      (accumulator, currentValue) => {
        if (
          currentValue.optionName
            .toLowerCase()
            .indexOf(this.state.filterKeyword) > -1
        ) {
          let element = (
            <FormControlLabel
              key={`${Math.random()}`}
              value={currentValue.optionName}
              style={this.props.compact ? { height: "25px" } : undefined}
              control={
                <Checkbox
                  key={`${Math.random()}`}
                  checked={currentValue.checked}
                  onChange={(e) => {
                    currentValue.checked = !currentValue.checked;
                    this.setState({});
                    this.props.onChange && this.props.onChange();
                  }}
                  color="primary"
                />
              }
              label={currentValue.optionName}
              labelPlacement="end"
            />
          );

          accumulator.push(element);
        }
        return accumulator;
      },
      []
    );

    return <FormGroup>{filteredResult}</FormGroup>;
  }
  checkBoxOnChange() {}
  render() {
    return (
      <div className="FilterListContainer">
        {!this.props.noFilterBox && (
          <div className="FilterListSearchInput">
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "filterKeyword",
                  dataType: "text",
                  hint: "Enter Keyword",
                },
                row: this.state,
              }}
              onChange={(a, v) => {
                this.setState({
                  filterKeyword: v.toLowerCase(),
                  // filter: false,
                });
              }}
            />
          </div>
        )}
        <div
          className="FilterListItemsContainer"
          style={{ height: this.props.height + "px" }}
        >
          {this.renderListItem()}
        </div>
        <div className="FilterListToggleSelectAll">
          <Button
            color="primary"
            variant="outline"
            onClick={() => {
              this.props.listData.forEach((obj) => {
                obj.checked = true;
                this.setState({});
              });
            }}
          >
            Select all
          </Button>
          <Button
            color="primary"
            variant="outline"
            onClick={() => {
              this.props.listData.forEach((obj) => {
                obj.checked = false;
                this.setState({});
              });
            }}
          >
            Clear all
          </Button>
          {this.props.customFilters &&
            this.props.customFilters.map((i) => (
              <Button
                color="primary"
                variant="outline"
                onClick={() => {
                  this.props.listData.forEach((obj) => {
                    obj.checked = i.eval(obj);
                  });
                  this.setState({});
                }}
              >
                {i.label}
              </Button>
            ))}
        </div>
      </div>
    );
  }
}

export default FilterList;
